import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { cartDeliveryPromiseTranslationKey } from "@/utils/deliveryPromise";

type DeliveryPromiseComponentProps = {
    item: OrderItemModel;
    deliveryType: DeliveryType;
};

const DeliveryPromiseComponent = ({
    item,
    deliveryType
}: DeliveryPromiseComponentProps) => {
    const { t } = useGranite();

    const deliveryPromiseTk = cartDeliveryPromiseTranslationKey({
        deliveryPromise: item.deliveryPromise,
        deliveryType: deliveryType
    });

    return (
        <p className={"m-0"}>
            {!item.warrantyDeposit &&
                (!item.boxProduct ||
                    (item.boxProduct &&
                        deliveryType === DeliveryType.HomeDelivery)) &&
                deliveryPromiseTk &&
                t(
                    deliveryPromiseTk,
                    item.deliveryPromise?.deliveryTime,
                    t(
                        `product.deliveryPromise.timeUnits.${item.deliveryPromise?.deliveryTimeUnit}`
                    )
                )}
            {item.boxProduct &&
                deliveryType === DeliveryType.ClickAndCollect &&
                (item.boxLogisticInformation ||
                    t(`ecommerce.label.pickup.box.${item.sku}`))}
        </p>
    );
};

export { DeliveryPromiseComponent };
